import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

import {IDType} from 'utils/prop-types';
import {getCurrentRanges} from 'utils/xps';

import {Banner} from '../Banner';

import Entry from './Entry';

const ExperienceSamplingBanner = ({entries, now}) => (
    entries && (
        <Banner
            className="current-samplings"
            entries={entries.map(entry => ({...entry, key: entry.id}))}
            Entry={Entry}
            now={now}
        />
    )
);

ExperienceSamplingBanner.propTypes = {
    now: PropTypes.instanceOf(Date).isRequired,
    entries: PropTypes.arrayOf(
        PropTypes.shape({
            id: IDType,
            end: PropTypes.number.isRequired,
            start: PropTypes.number.isRequired,
        }),
    ),
};

ExperienceSamplingBanner.defaultProps = {
    entries: null,
};

const mapStateToProps = ({experiencesampling}) => {
    const now = new Date();
    const entries = getCurrentRanges(experiencesampling);

    return {
        entries,
        now,
    };
};

export default connect(mapStateToProps)(ExperienceSamplingBanner);



// WEBPACK FOOTER //
// ./scripts/frontend/questionnaires/components/ExperienceSamplingBanner/index.js